// extracted by mini-css-extract-plugin
export default {"employeeList":"employee_cadastre_list_employeeList__UdeOH","Mui-focused":"employee_cadastre_list_Mui-focused__vS3Xk","label":"employee_cadastre_list_label__st5em"};